export default "__VITE_ASSET__3bc22d4b__"